var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nopic"},[_c('div',[_c('p',[_vm._v("上传时间已到，请您重新扫描二维码进入！")])])])}]

export { render, staticRenderFns }